
<section>
  <div class="inner-box">
    <div class="text-center">
      <h1>{{order?.accountOwnerCompany}}</h1>
    </div>

    <div>
      <div >
        <h1 class="p-4"># {{order?.orderNumber}}</h1>
      </div>
      <div class="row py-3 ps-4" *ngFor="let order of orders">
        <div class="col-5 ps-3">
          <p>{{order.productName}}</p>
        </div>
        <div class="col-2 ps-4">
          <p>: {{order.quantity}}</p>
        </div>

      </div>
    </div>

    <div class="ps-4">
      <p><strong>Please select your Return Order Type</strong></p>
      <div class="d-flex flex-row">
        <div class="pt-1 p-2">
          <input type="radio" id="FR" name="returnType" value="FR" class="me-2" (click)="onFullReturn()">
          <label for="FR" class="pb-1">Full Order Return</label><br>
        </div>
        <div class="pt-1 p-2">
          <input type="radio" id="PR" name="returnType" value="CSS" class="me-2" (click)="onPartialReturn()">
          <label for="PR" class="pb-1">Partial Order Return</label><br>
        </div>
      </div>
    </div>

    <div class="pt-3"  *ngIf="returnType ==='FullReturn' && orders?.length > 0">
      <div class="mx-4 my-2">
        <label style="white-space: nowrap;"><strong>Select Return Reason</strong></label>
        <ng-select [ngClass]="{'is-invalid':reasonError}"
                   placeholder="Select Reason" [(ngModel)]="order.returnReason" (blur)="typeError()"
                   [ngModelOptions]="{standalone: true}" required [items]="returnReasons" bindLabel="config"
                   bindValue="config">
        </ng-select>
        <div id="selectReasonError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!selectReasonError">
          {{selectReasonError}}
        </div>

      </div>
      <div class="row ps-4 pt-4 pb-2">
        <div class="col">
          <p>Product Name</p>
        </div>
        <div class="col">
          <p>Quantity</p>
        </div>
      </div>

      <div class="row pb-2" *ngFor="let ol of orders;let i=index">
        <div class="col ms-4">{{ol.productName}}</div>
        <div class="col">
          <input style="width:50px;" type="text" id="quantity"
                 (keyup)="onKey($event,ol,i)"
                 [(ngModel)]="ol.quantity"
                 appOnlyNumbers
                 [ngModelOptions]="{standalone: true}" class="form-control text-center" required
                 disabled
          />
        </div>


      </div>
      <div class="row d-flex justify-content-between">
        <div class="col-6 ">

        </div>
        <div class="col-6 p-3 ">
          <button class="btn-orange text-center float-end" (click)="submitReturn() ">Confirm Return</button>
        </div>
      </div>

    </div>


    <div class="pt-3" *ngIf="returnType == 'PartialReturn' && orderLines?.length > 0">
      <div class="mx-4 my-2">
        <label style="white-space: nowrap;">Select Return Reason</label>
        <ng-select [ngClass]="{'is-invalid':selectReasonError}"
                   placeholder="Select Reason" [(ngModel)]="order.returnReason" (blur)="typeError()"
                   [ngModelOptions]="{standalone: true}" required [items]="returnReasons" bindLabel="config"
                   bindValue="config">
        </ng-select>
        <div id="selectReasonError1" class="invalid-feedback d-block shift-invalid-login" [hidden]="!selectReasonError">
          {{selectReasonError}}
        </div>
      </div>


      <div class="row d-flex flex-row ps-4 pt-4 pb-2">
        <div class="col-6">
          <p>Product Name</p>
        </div>
        <div class="col-6">
          <p>Quantity</p>
        </div>
      </div>


      <div>
        <div class="row pb-2" *ngFor="let ol of orderLines;let i=index">
          <div class="col ms-4">{{ol.productName}}</div>
          <div class="col">
            <div class="row">
              <div class="col-3">
                <input style="width:50px;" type="text" id="ol.quantity"
                       (keyup)="onKey($event,ol,i)"
                       [(ngModel)]="ol.quantity"
                       appOnlyNumbers
                       [ngModelOptions]="{standalone: true}" class="form-control" required
                       [disabled]="ol.previousQuantity==1"
                       [ngClass]="{'is-invalid':invalidProductNoEntryError[i]}" />
                <div id="invalidProductNoEntryError" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!invalidProductNoEntryError[i]" style="position: absolute;">
                  {{invalidProductNoEntryError[i]}}
                </div>
              </div>

              <div class="col-2 float-start">
                <a style="position:relative;top:7px;"  [hidden]="ol.previousQuantity==1" (click)="removeProduct(ol)">
                  <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                    <defs>
                      <style>.a {
                              fill: #848484;
                            }</style>
                    </defs>
                    <path class="a"
                          d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z"
                          transform="translate(-7.5 -4.5)"/>
                  </svg>
                </a>
              </div>

            </div>
          </div>
          <div class="row d-flex justify-content-between">
            <div class="col-6 ">

            </div>
            <div class="col-6 p-3 ">
              <button class="btn-orange text-center float-end" (click)="submitReturn()">Confirm Return</button>
            </div>
          </div>
        </div>


      </div>
    </div>

  </div>
</section>
